import { styles, DrawerLayoutTheme } from '../DrawerLayoutStyles.css';
import { baseTheme } from './DrawerLayoutBaseTheme.css';
import { multiVariantStyles } from './DrawerLayoutVariants.css';

/*******************
 * Component Theme
 *******************/

const DrawerLayoutStableTheme: DrawerLayoutTheme = {
  baseTheme,
  styles,
  multiVariantStyles
};

/*******************
 * Exports
 *******************/

export { DrawerLayoutStableTheme };
